import StockoutBrandPanel from './stockoutBrandPanel.container';

export default StockoutBrandPanel;